import script from "./BirthdayPopupIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayPopupIndex.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayPopupIndex.vue?vue&type=style&index=0&id=755b86fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755b86fe"]])

export default __exports__